/**
 * Status filter constants for the StatusFilterDropdown.
 *
 * Kept in a non-component module so the dropdown component file exports only
 * React components (and types). eslint-plugin-react-refresh's
 * `only-export-components` rule flags non-literal value exports (such as this
 * `as const` array) when they sit beside a component, which would break Fast
 * Refresh boundaries. See shipcast-7i0.
 */

/** Status filter values for due date/risk filtering */
export const STATUS_FILTER_VALUES = ['due', 'nodue', 'risk', 'safe'] as const;

export type StatusFilterValue = (typeof STATUS_FILTER_VALUES)[number];
